import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledCarouselRoundArrowComponent } from "./carousel-round-arrow-component.scss";
import classnames from "classnames";
class CarouselRoundArrowComponent extends PureComponent {
    render() {
        const { className, style, onClick } = this.props;
        return /*#__PURE__*/ _jsx(StyledCarouselRoundArrowComponent, {
            className: classnames(className, "carousel-round-arrow"),
            onClick: onClick
        });
    }
    constructor(props){
        super(props);
    }
}
export { CarouselRoundArrowComponent as default };
